class NullState {
  onCompletion() {}

  onPerformed() {}

  onStart() {}

  onRunning() {}

  onQueued() {}

}

export default NullState;